module.exports = __webpack_public_path__ + "img/QDLOp3qTiVzuezlhsT44y.2241dc5c.svg";